<template>
  <div id="modalProvenanceContainer">
    <button class="mpModalBtn" v-b-modal="'modal-' + this.uid">
      Provenance
    </button>

    <b-modal size="xl" modal-class="mdModal" :id="'modal-' + this.uid" hide-footer centered>
      <template #modal-header="{ close }">
        <div class="mdTitle">La poids de <span>{{item.sec.name}}</span> dans votre patrimoine : {{Math.round(item.weight_total*100)/100}}%</div>
        <b-icon icon="x" @click="close()" style="color: white"></b-icon>
      </template>

      <template class="mdModal">
        <b-row>
          <b-col class="mpCard">
            <div class="mpCardTitle">Allocation direct</div>
            <div class="mpCardContent mt-4">{{item.sec.name}} ISIN : {{item.sec.isin}}</div>
            <div class="mpCardNumber mt-4">{{ Math.round(weight_direct * 100) / 100 }} %</div>
          </b-col>
          <b-col v-if="weight_etf != 0" class="mpCard">
            <div class="mpCardTitle">Allocation indirect</div>
            <div
              style="background: #121212 0% 0% no-repeat padding-box;
                border-radius: 20px;
                opacity: 1;
                padding:15px"
            >
              <b-row style="color: white">
                <b-col>Fonds</b-col>
                <b-col>ISIN</b-col>
                <b-col>Poids</b-col>
              </b-row>
              <b-row style="color: white" v-for="(item, index) in item.etf" :key="index">
                <b-col>{{ item.security.name }}</b-col>
                <b-col>{{ item.security.isin }}</b-col>
                <b-col>{{ Math.round(item.weight * 100) / 100 }} %</b-col>
              </b-row>
              <b-row class="mpCardNumber">
                <b-col><div>Total indirect</div></b-col>
                <b-col>
                  <div>{{ Math.round(weight_etf * 100) / 100 }} %</div>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
        <!-- <div v-html="content" class="modalContentCustom"></div> -->
      </template>
    </b-modal>
  </div>
</template>
<script>
export default {
  props: ["weight_direct", "weight_etf", "item"],
};
</script>
<style lang="scss">
@import "../../../../../sass/_variables.scss";
#modalProvenanceContainer {
  .mpModalBtn {
    background: transparent;
    border: none;
    color: $purple_color;
    font-weight: bold;
  }
}
.mdModal {
  .modal-content {
    background: #121212 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 20px;
    opacity: 1;
    .modal-header {
      border-bottom: none;
      .mdTitle {
        text-align: center;
        font: normal normal normal $mf_ft_size_big_title Dosis;
        letter-spacing: 0px;
        color: $mf_ft_color_white;
        opacity: 1;
        span {
          color: $purple_color;
        }
      }
    }
    .mpCard {
      background: #242527 0% 0% no-repeat padding-box;
      border-radius: 20px;
      opacity: 1;
      padding: 20px;
      .mpCardTitle {
        text-align: center;
        font: normal normal bold $mf_ft_size_text Segoe UI;
        letter-spacing: 0px;
        color: #9561e2;
        opacity: 1;
      }
      .mpCardContent {
        text-align: center;
        font: normal normal normal $mf_ft_size_text Segoe UI;
        letter-spacing: 0px;
        color: $mf_ft_color_white;
        opacity: 1;
      }
      .mpCardNumber {
        text-align: center;
        font: normal normal normal $mf_ft_size_text Segoe UI;
        letter-spacing: 0px;
        color: #9561e2;
        opacity: 1;
      }
    }
  }
}
</style>
